import { FaCheckCircle } from "react-icons/fa";

interface IFormSuccessProps {
    message?: string;
}

export const FormSuccess = ({ message }: IFormSuccessProps) => {
    if (!message) return null;

    return (
        <div className="flex items-center gap-x-2 rounded-md bg-emerald-500/15 p-3 text-sm text-emerald-500">
            <FaCheckCircle className="size-4" />
            <p>{message}</p>
        </div>
    );
};